<template>
  <div v-if="visible" class="modal-overlay" @click="onClose" role="dialog" aria-modal="true" :aria-labelledby="titleId">
    <div class="modal-content" @click.stop>
      <div class="modal-header">
        <h2 :id="titleId">{{ title }}</h2>
        <ActionButton 
          button-class="close-btn"
          @click="onClose"
          :aria-label="`关闭${title}模态框`"
        >
          &times;
        </ActionButton>
      </div>
      <div class="modal-body">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import ActionButton from './ActionButton.vue';

export default {
  name: 'BaseModal',
  components: {
    ActionButton
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      required: true
    },
    titleId: {
      type: String,
      required: true
    }
  },
  emits: ['close'],
  methods: {
    onClose() {
      this.$emit('close');
    }
  }
}
</script>

<style scoped>
/* 模态框样式 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: rgba(13, 26, 45, 0.95);
  border-radius: 15px;
  padding: 0;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
  border: 1px solid rgba(102, 126, 234, 0.5);
  max-width: 90%;
  width: 400px;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 25px 10px;
  border-bottom: 1px solid rgba(102, 126, 234, 0.3);
}

.modal-header h2 {
  color: #ffcc00;
  margin: 0;
  text-shadow: 0 0 5px rgba(255, 204, 0, 0.3);
}

.modal-body {
  padding: 25px;
}

/* 移动端模态框 */
@media (max-width: 768px) {
  .modal-content {
    width: 95%;
    margin: 0 10px;
  }
  
  .modal-header {
    padding: 15px 20px 5px;
  }
  
  .modal-body {
    padding: 20px;
  }
}

/* 确保模态框在小屏幕上也能正常显示 */
@media (max-width: 480px) {
  .modal-content {
    width: 95%;
    max-width: none;
    margin: 0 10px;
  }
  
  .modal-header h2 {
    font-size: 1.3rem;
  }
}
</style>